// import { input } from "@material-tailwind/react";
import React, { useReducer } from 'react';
import { useRef } from 'react';
import { IoSearch, IoClose } from 'react-icons/io5';

export default function Subtitle({ switchTabs, handleQuery, activeTab }) {
  const [isInputFocused, toggleFocus] = useReducer((s) => !s, false);

  let inputRef = useRef(null);

  const handleFormSubmisson = (event) => {
    event.preventDefault();
    handleQuery(inputRef.value);
    toggleFocus();
    inputRef.value = '';
  };

  return (
    <div>
      <h3 className="font-gilroylight text-center xxl:mb-20 xl:mb-16 lg:mb-12 md:mb-8 mb-4 px-10">
        You have questions, <br className="sm:block hidden" />
        <b>we have answers</b>
      </h3>
      {/* <div className="grid place-content-center xxl:mb-20 xl:mb-16 lg:mb-12 md:mb-8 mb-4">
        <div className="py-3 w-full rounded-ful divide-x divide-black divide-2 bg-grey flex flex-wrap gap-y-5 items-center justify-center pl-5 pr-5 relative overflow-hidden">
          <button
            onClick={() => switchTabs('all')}
            className={`${
              activeTab === 'all' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            All
          </button>

          <button
            onClick={() => switchTabs('ev-charger')}
            className={`${
              activeTab === 'ev-charger' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Chargers
          </button>
          <button
            onClick={() => switchTabs('controllers')}
            className={`${
              activeTab === 'controllers' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Controllers
          </button>
          <button
            onClick={() => switchTabs('simulator')}
            className={`${
              activeTab === 'simulator' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Simulator
          </button>

          <button
            onClick={() => switchTabs('cms')}
            className={`${
              activeTab === 'cms' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Applications
          </button>
          <button
            onClick={() => switchTabs('payments')}
            className={`${
              activeTab === 'payments' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Payments
          </button>

          <button
            onClick={() => switchTabs('general')}
            className={`${
              activeTab === 'general' ? 'text-green' : ''
            } px-6  md:text-lg  font-poppins`}
          >
            Other
          </button>

          <div
            className={`absolute hidden top-0 bottom-0 w-full bg-gradient rounded-l-full  border-none transition-all duration-300  outline-none overflow-hidden ${
              isInputFocused ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <form
              onSubmit={handleFormSubmisson}
              className="flex flex-nowrap gap-2 h-full pl-7 items-center  "
            >
              <IoSearch size={26} />
              <input
                ref={(el) => (inputRef = el)}
                type="text"
                placeholder="Search"
                className="bg-gradient text-white placeholder:text-white rounded-l min-h-full  outline-none  text-lg font-poppins pl-3 pr-3 flex-1"
              />
            </form>
          </div>
          <button
            type="submit"
            onClick={toggleFocus}
            className="bg-gradient hidden rounded-full p-3 hover:shadow-md border-none absolute top-0 right-0 bottom-0 hover:fill-white fill-black z-10"
          >
            {isInputFocused ? (
              <div className="p-[2px] rounded-full bg-black">
                <IoClose size={26} fill="white" />
              </div>
            ) : (
              <IoSearch size={26} fill="inherit" />
            )}
          </button>
        </div>
      </div> */}
    </div>
  );
}
